import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import AddHobby from "./hobbies/AddHobby";
import HobbyList from "./hobbies/HobbyList";


export default function HobbiesSection() {

    const [ isVisible, setIsVisible ] = useState( false );
    const { translations } = useContext( TranslationContext );

    return (
        <div className="text-white">
            <div className="subtitre-cv-container text-underline d-flex align-items-center gap-2 mb-3"
                 onClick={ () => setIsVisible( !isVisible ) }
                 style={ { cursor: "pointer" } }
            >
                <h4 className="text-underline pt-1 text-white">{ translations.hobbiesSection.title }</h4>
                <div className="line bg-white"></div>
                <MDBIcon
                    fas
                    icon={ "futbol" }
                    style={ { color: "white" } }
                    size="lg"
                />
            </div>
            { isVisible && (
                <>
                    <HobbyList/>
                    <AddHobby/>
                </>
            ) }
        </div>
    );
}
